// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 240) return "static/chunks/240-ec7291b398131eed.js";
	if (chunkId === 48) return "static/chunks/48-9db583002c1a7b87.js";
	if (chunkId === 855) return "static/chunks/855-8be37752cc483cc7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"254":"6811934fabc6a315","258":"543c6d9a38ae571e","710":"81d84420db150ddd","791":"443720ebc44616e1","910":"dd125f334cd14668"}[chunkId] + ".js";
};